import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Controls = styled.div`
  display: grid;
  gap: 16px;

  ${({theme}) =>
    theme.respondTo(
      'lg',
      css`
        grid-template-columns: none;
        grid-auto-flow: column;
      `
    )}
`;
